<template>

  <div class="bulk-issue-validation-control">
     <b-button-group size="sm"
      > <b-button
        :variant="activeView === 'eligible' ? 'primary' : 'outline-secondary'"
        @click="$emit('change', 'eligible')"
        > Hợp lệ ({{ eligibleCount }}) </b-button
      > <b-button
        :variant="blockedVariant"
        @click="$emit('change', 'blocked')"
        > Bị chặn ({{ blockedCount }}) <span
          v-if="blockedCount > 0"
          class="bulk-issue-validation-control__alert"
        >Cần xử lý</span
        > </b-button
      > </b-button-group
    >
  </div>

</template>

<script>
  export default {
    name: 'BulkIssueValidationControl',
    props: {
      activeView: {
        type: String,
        default: 'eligible',
      },
      eligibleCount: {
        type: Number,
        default: 0,
      },
      blockedCount: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      blockedVariant() {
        if (this.activeView === 'blocked') {
          return this.blockedCount > 0 ? 'warning' : 'secondary'
        }

        return this.blockedCount > 0 ? 'outline-warning' : 'outline-secondary'
      },
    },
  }
</script>

<style scoped>
  .bulk-issue-validation-control {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .bulk-issue-validation-control__alert {
    display: inline-flex;
    align-items: center;
    margin-left: 0.4rem;
    padding: 0.1rem 0.42rem;
    border-radius: 999px;
    background: rgba(212, 72, 72, 0.14);
    color: #a23838;
    font-size: 0.66rem;
    font-weight: 700;
    line-height: 1.2;
  }
</style>
